import type { FC } from 'react';

import { useContentfulQuery } from '../../hooks/useContentfulQuery';
import { EditorialGallery } from './EditorialGallery';
import { Gallery } from './Gallery';
import type { LazyGalleryQueryResponse } from './query';
import { lazyGalleryQuery } from './query';
import { type LazyGalleryProps, GalleryType } from './types';

export const LazyGallery: FC<LazyGalleryProps> = props => {
  const galleryId = props.sys.id;

  const { data: galleryData } = useContentfulQuery<
    LazyGalleryQueryResponse,
    {
      id: string;
    }
  >(lazyGalleryQuery, {
    variables: { id: galleryId },
  });

  const gallery = galleryData?.gallery;
  const isEditorialGallery = gallery?.galleryType === GalleryType.EDITORIAL;

  if (!gallery) {
    return null;
  }

  return isEditorialGallery ? (
    <EditorialGallery gallery={gallery} />
  ) : (
    <Gallery gallery={gallery} />
  );
};

LazyGallery.displayName = 'LazyGallery';
